"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { ControlContainer, CurrencyIcon } from "@workspace/frontend-ui";
import type { FC } from "react";

const NO_CURRENCY_PLACEHOLDER = "—";

type Props = {
  // "div" when nested inside another button, e.g. the currency dropdown's trigger — nesting buttons is invalid HTML.
  as?: "button" | "div";
};

const GameCurrencyIcon: FC<Props> = ({ as = "button" }) => {
  const { inGameCurrency } = useGamePageData();

  if (!inGameCurrency) {
    return (
      <ControlContainer as={as} noClickable>
        <span className="text-xs">{NO_CURRENCY_PLACEHOLDER}</span>
      </ControlContainer>
    );
  }

  return (
    <ControlContainer as={as} noClickable>
      <CurrencyIcon currency={inGameCurrency} className="size-6!" />
    </ControlContainer>
  );
};

export default GameCurrencyIcon;
